import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
	root: {},
	subHeader: {
		marginBottom: theme.spacing(2),
	},
	subsequentHeader: {
		marginTop: theme.spacing(3),
	},
	userListContainer: {
		height: 550,
		marginTop: theme.spacing(2),
	},
	userList: {
		margin: theme.spacing(2, 0),
	},
	loadingListItem: {
		height: 74,
	},
	listItem: {
		display: 'flex',
		justifyContent: 'space-between',
		padding: theme.spacing(2, 0),
		'& + &': {
			borderTop: `1px solid ${theme.palette.divider}`,
		},
	},
	userDetails: {
		marginLeft: theme.spacing(3),
	},
	formGroup: {
		margin: theme.spacing(2, 0),
	},
	paginationContainer: {
		display: 'flex',
		justifyContent: 'center',
	},
}));
